import { Reveal, Chapter } from "./Reveal";

const About = () => (
  <section id="about" className="scroll-mt-24 py-24 sm:py-32" data-testid="about-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="order-2 lg:order-1 lg:col-span-6">
        <Reveal>
          <Chapter num="07" label="About Bella Bells Cakes" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl font-light leading-tight tracking-tight text-[#2D2422] sm:text-5xl">
            Made with Love in San Diego
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-[#5C4B47] sm:text-lg">
            Bella Bells Cakes is a licensed San Diego bakery specializing in custom cakes and
            handcrafted desserts made for life&rsquo;s sweetest celebrations.
          </p>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-[#5C4B47]">
            From the flavor inside to the finishing details outside, every cake is thoughtfully
            created to make your event feel a little more special.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-8 font-display text-2xl italic text-[#C48B71]" data-testid="about-signature">
            &mdash; Bella Bells Cakes, est. 2021
          </p>
        </Reveal>
      </div>

      <Reveal className="order-1 lg:order-2 lg:col-span-5 lg:col-start-8">
        <div className="arch-frame overflow-hidden">
          <img
            src="/images/about.jpg"
            alt="Baker hand-decorating a custom cake at Bella Bells Cakes, San Diego"
            loading="lazy"
            className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
            data-testid="about-image"
          />
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
